import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ResolveCategory} from "../../services/data.service";
import {ExtensionCategory} from "../../../../functions/src/types";
import invert from "invert-color";

@Component({
  selector: 'app-category-tag',
  templateUrl: './category-tag.component.html',
  styleUrls: ['./category-tag.component.scss']
})
export class CategoryTagComponent implements OnInit {
  private category_: string = null;
  @Input('category') set category(value) {
    console.log('CategoryTagComponent::: ', value);
    this.category_ = value;
    this.updateCategory();
  }
  @Input() clickable = false;
  @Input() name = true;
  // @Input() background = true;
  @Output() itemClick = new EventEmitter();

  public categoryType: ExtensionCategory;

  constructor(private resolveCategory: ResolveCategory) { }

  ngOnInit(): void { }

  updateCategory() {
    this.categoryType = this.resolveCategory.transform(this.category_) || null;
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

}
